export default "__VITE_ASSET__ysWPmnNR__"